import {
    DeleteOutlined,
    EditFilled, FolderOpenFilled,
    ExclamationCircleOutlined
} from "@ant-design/icons";
import {
    Button, Col, Image, Modal, Input, Form
} from "antd";
import { useState, useEffect } from "react";
import Paginate from "./../../commons/Paginate";
import MainLayout from "./../../components/mainLayout";
import "./index.scss";
import { authApis } from "../../services/authApi";
import { nofication } from "./../../commons/Nofication";

const Register = () => {

    const [newsList, setNewsList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [value, setValue] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [name, setNamfolder] = useState("");
    const [currentFolder, setCurrenFolder] = useState("");
    const [bracum, setBracum] = useState([]);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        const data = { name: name, currentFolder: currentFolder };
        authApis
            .newFolder(data)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                folderImg(currentFolder);
                setIsModalVisible(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&search=${searchValue}`;
        authApis
            .getMedia('')
            .then((data) => {
                setNewsList(data.files ?? []);
                setCurrenFolder(data.currenFolder);
                // setTotalItem(data.lang.total ?? 0);
                // setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const [valueForm, setValueForm] = useState({
        name: "",
        email: "",
        password: "",
        comfirmPassword: "",
    });

    // const onSetState = () => {
    //     setBracum([]);
    // }

    const folderImg = (dir) => {
        const urlParams = `dir=${dir}`;
        setCurrenFolder(dir);
        const dataNew = dir.split('/');
        const data = { name: dataNew[dataNew.length - 1], dir: dir };
        const indexOf = bracum.findIndex(aaa => aaa.name === data.name);
        console.log(indexOf);
        const newa = bracum.splice(indexOf + 1);
        indexOf > -1 ? ''  : setBracum([...newa, data]);
        if (dir === 'userfiles/images') {
            setBracum([]);
        }
        authApis
            .getMedia(urlParams)
            .then((data) => {
                setNewsList(data.files ?? []);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onDelete = (id) => {
        const data = { name: id.slice(1) };
        authApis
            .deleteImg(data)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                folderImg(currentFolder);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có muốn xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };

    const onUploadfile = (e) => {
        const formData = new FormData();
        formData.append('file', e.target.files[0]);
        formData.append('folder', currentFolder);
        authApis
            .uploadFile(formData)
            .then((data) => {
                nofication("success", "Thành công!", "Upload thành công!");
                folderImg(currentFolder);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Upload thất bại!");
            });
    };

    const onChangeName = (e) => {
        setNamfolder(e.target.value);
    };

    return (
        <MainLayout
            isShowActionHeader={true}
            title="Media"
            link="/media/"
            titleNew="Media / List"
            isMedia={true}
            isHiddenAction={true}
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            onUploadfile={onUploadfile}
        >
            <Modal title="New folder" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Form.Item title="Folder name">
                    <Input onChange={onChangeName} />
                </Form.Item>
            </Modal>
            <Col span={24} className='main-min-height-table'>
                <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className="table"
                    >
                    <p style={{ fontWeight: 'bold', textTransform: 'capitalize', cursor: 'pointer' }}><span onClick={() => folderImg('userfiles/images')}>Home</span>
                        {bracum.map((item, index) => {
                            return <span key={index} onClick={() => folderImg(item.dir)}>/{item.name}</span>;
                        })}
                    </p>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">File</th>
                                <th scope="col">FileName</th>
                                <th scope="col">Created_at</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                newsList.length > 0 ?
                                    newsList.map((item) => {
                                        return (
                                            <tr key={item}>
                                                <th scope="row">
                                                    {
                                                        item.type === 'folder' ?
                                                            <img src="/icon/folder_media.svg" alt="" width={"100"} onClick={() => folderImg(item.content)} />
                                                            :
                                                            <Image src={item.content} width={"100"} />
                                                    }
                                                </th>
                                                <th scope="row">{item.origin}</th>
                                                <td>22-03-18 00:00:00</td>
                                                <td>
                                                    <Button
                                                        icon={<EditFilled />}
                                                        style={{
                                                            color: "white",
                                                            background: "black",
                                                            border: "black",
                                                        }}
                                                    ></Button>
                                                    <Button
                                                        icon={<DeleteOutlined />}
                                                        style={{
                                                            color: "white",
                                                            background: "#ab1a1a",
                                                            border: "#ab1a1a",
                                                            marginLeft: 10,
                                                        }}
                                                        onClick={() =>
                                                            onConfirmDelete(
                                                                item.content
                                                            )
                                                        }
                                                    ></Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                    :
                                    <tr>
                                        <td colspan="9">
                                            <h4
                                                style={{
                                                    textAlign: "center",
                                                    margin: "20px 0px",
                                                }}
                                            >
                                                (No data)
                                            </h4>
                                        </td>
                                    </tr>
                            }
                            {/* {} */}
                        </tbody>
                    </table>
                    <Paginate />
                </div>
            </Col>
        </MainLayout>
    );
};

export default Register;
